import React, { Component } from "react";
import SignleEmailForm from "../../../Containers/SingleEmailValidation";

const inlineStyles = {
  PaddingLeft: { paddingleft: 0 },
  MarginTop: { marginTop: 0 },
  FileUpload: { fontSize: 80, fontWeight: 200, opacity: 0.5, left: 40, top: 10 }
};

class SingleEmailVerification extends Component {
  render() {
    return (
      // <div class="right_col" role="main">
      <div className="col-md-6 col-sm-12 col-xs-12">
        <div className="x_panel emails_box">
          <div className="x_title">
          <h2 className="float-left">Single Email Verification</h2>
            <ul className="nav navbar-right panel_toolbox">
              <li />
            </ul>
            <div className="clearfix" />
          </div>
          <div className="x_content">
            <SignleEmailForm />
          </div>
        </div>
      </div>
      // </div>
    );
  }
}

export default SingleEmailVerification;



// WEBPACK FOOTER //
// ./src/components/EmailVerification/EmailVerificationContainer/SingleEmailVerification.js